import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles, globalClasses } from "../Radio.styles";
export var Radio = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Radio, _React$Component);

  function Radio() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.theme = void 0;
    _this.inputEl = /*#__PURE__*/React.createRef();

    _this.renderMain = function (props) {
      var _cx;

      var active = props.active,
          _props$disabled = props.disabled,
          disabled = _props$disabled === void 0 ? _this.context.disabled : _props$disabled,
          _props$warning = props.warning,
          warning = _props$warning === void 0 ? _this.context.warning : _props$warning,
          _props$error = props.error,
          error = _props$error === void 0 ? _this.context.error : _props$error,
          focused = props.focused,
          pressed = props.pressed,
          hovered = props.hovered,
          onMouseOver = props.onMouseOver,
          onMouseEnter = props.onMouseEnter,
          onMouseLeave = props.onMouseLeave,
          onValueChange = props.onValueChange,
          rest = _objectWithoutPropertiesLoose(props, ["active", "disabled", "warning", "error", "focused", "pressed", "hovered", "onMouseOver", "onMouseEnter", "onMouseLeave", "onValueChange"]);

      var radioProps = {
        className: cx((_cx = {}, _cx[styles.radio(_this.theme)] = true, _cx[styles.checked(_this.theme)] = _this.props.checked, _cx[styles.focus(_this.theme)] = _this.props.focused, _cx[styles.error(_this.theme)] = error, _cx[styles.warning(_this.theme)] = warning, _cx[styles.disabled(_this.theme)] = disabled, _cx[styles.checkedDisabled(_this.theme)] = _this.props.checked && disabled, _cx[globalClasses.radio] = true, _cx))
      };
      var value;

      if (typeof _this.props.value === 'string' || typeof _this.props.value === 'number') {
        value = _this.props.value;
      }

      var inputProps = _extends({}, rest, {
        type: 'radio',
        className: styles.input(_this.theme),
        disabled: disabled,
        tabIndex: _this.props.tabIndex,
        value: value,
        ref: _this.inputEl,
        onChange: _this.handleChange
      });

      var labelProps = {
        className: cx(styles.root(_this.theme), _this.props.checked && styles.rootChecked(_this.theme)),
        onMouseOver: _this.handleMouseOver,
        onMouseEnter: _this.handleMouseEnter,
        onMouseLeave: _this.handleMouseLeave
      };

      if (_this._isInRadioGroup()) {
        var _cx2;

        var checked = _this.props.value === _this.context.activeItem;
        inputProps.checked = checked;
        inputProps.name = _this.context.name;
        inputProps.suppressHydrationWarning = true;
        radioProps.className = cx(radioProps.className, (_cx2 = {}, _cx2[styles.checked(_this.theme)] = checked, _cx2[styles.checkedDisabled(_this.theme)] = checked && disabled, _cx2));
      }

      return /*#__PURE__*/React.createElement("label", labelProps, /*#__PURE__*/React.createElement("input", inputProps), /*#__PURE__*/React.createElement("span", radioProps, /*#__PURE__*/React.createElement("span", {
        className: styles.placeholder()
      })), _this.props.children && _this.renderLabel());
    };

    _this._isInRadioGroup = function () {
      return Boolean(_this.context.name);
    };

    _this.handleChange = function (e) {
      _this.props.onValueChange == null ? void 0 : _this.props.onValueChange(_this.props.value);

      if (_this._isInRadioGroup()) {
        _this.context.onSelect(_this.props.value);
      }

      _this.props.onChange == null ? void 0 : _this.props.onChange(e);
    };

    _this.handleMouseOver = function (e) {
      _this.props.onMouseOver == null ? void 0 : _this.props.onMouseOver(e);
    };

    _this.handleMouseEnter = function (e) {
      _this.props.onMouseEnter == null ? void 0 : _this.props.onMouseEnter(e);
    };

    _this.handleMouseLeave = function (e) {
      _this.props.onMouseLeave == null ? void 0 : _this.props.onMouseLeave(e);
    };

    return _this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(CommonWrapper, _this2.props, _this2.renderMain);
    });
  }
  /**
  * @public
  */
  ;

  _proto.focus = function focus() {
    var _this$inputEl$current;

    (_this$inputEl$current = this.inputEl.current) == null ? void 0 : _this$inputEl$current.focus();
  }
  /**
  * @public
  */
  ;

  _proto.blur = function blur() {
    var _this$inputEl$current2;

    (_this$inputEl$current2 = this.inputEl.current) == null ? void 0 : _this$inputEl$current2.blur();
  };

  _proto.renderLabel = function renderLabel() {
    var _cx3;

    var labelClassNames = cx((_cx3 = {}, _cx3[styles.label(this.theme)] = true, _cx3[styles.labelDisabled()] = !!(this.props.disabled || this.context.disabled), _cx3));
    return /*#__PURE__*/React.createElement("div", {
      className: labelClassNames
    }, this.props.children);
  };

  return Radio;
}(React.Component);
Radio.__KONTUR_REACT_UI__ = 'Radio';
Radio.contextTypes = {
  activeItem: PropTypes.any,
  onSelect: PropTypes.func,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  warning: PropTypes.bool
};
Radio.defaultProps = {
  focused: false
};